module.exports = __webpack_public_path__ + "static/media/donate-notselected.0542cf17.svg";